export default __webpack_public_path__ + "static/media/DAI.196bd5b1.png";